import React from 'react';
import { Link } from 'react-router-dom';
import useLocalStorage from 'hooks/useLocalStorage';
import './Logout.css';
import { createPath, ROUTE } from 'utils/Routing';

const Logout = () => {
  const [, setValue] = useLocalStorage('AUTH');
  const redirect = createPath({ path: ROUTE.HOME });

  return (
    <div className='logout__container'>
      <div className='logout__question'>
        <i className='bx bx-question-mark' />
        <p className='logout__question-text'>Are you sure you want to logout?</p>
      </div>
      <div className='logout__button-container'>
        <Link type='button' to={redirect} className='action__button logout__button'>
          No
        </Link>
        <Link type='button' onClick={() => setValue(null)} to={redirect} className='action__button logout__button'>
          Yes
        </Link>
      </div>
    </div>
  );
};

export default Logout;
